import React, { useEffect, useState } from "react";
import "./Complementry.css";
import {
  apple_img,
  banana_img,
  Brocooli_img,
  child_right,
  Disappointed_face,
  fearfull_face,
  Grimacing_face,
  Smiling_face,
} from "assets/icons";
import useFullPageLoader from "common/UseFullPageLoader";
import { complementaryFeedingListApi } from "services/complementaryFeeding";
import { dateFormatWithTime } from "utils/dateFormat";

const reactionIcons = {
  "LOVE-IT": Smiling_face,
  "HATE-IT": Disappointed_face,
  MOH: Grimacing_face,
  "ALLERGY-SENSITIVITY": fearfull_face,
};

const reactionFormat = {
  "LOVE-IT": "Love It",
  "HATE-IT": "Hate It",
  MOH: "Moh",
  "ALLERGY-SENSITIVITY": "Allergy Sensitivity",
};

const Complementry = ({ _child }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [feedingList, setFeedingList] = useState([]);
  const [meta, setMeta] = useState({});
  const [selected, setSelected] = useState({});

  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await complementaryFeedingListApi({
        childId: _child,
        limit: 5000,
      });
      if (status === 200) {
        setFeedingList(data?.data);
        setMeta(data?.meta);
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {loader}
      <div className="complementry_parent">
        <div className="complementry_wraper">
          <div className="row">

            <div className="col-lg-5 col-md-6 col-sm-6">
              {feedingList.map((item, i) => {
                return (
                  <div
                    className={`complementry_lft_content ${
                      item?._id === selected?._id && "active"
                    }`}
                    key={i}
                    onClick={() => setSelected(item)}
                  >
                    <div className="complementry_card_header">
                      <div className="complementry_img">
                        <img
                          src={reactionIcons[item?.reaction]}
                          alt="smiley_emojy"
                        />
                        <div className="love_it">
                          <p>{reactionFormat[item?.reaction]}</p>
                        </div>
                      </div>

                      <div className="complementry_timimg">
                        <div className="time">
                          <p>{dateFormatWithTime(item?.feedingDateTime)}</p>
                        </div>
                      </div>
                    </div>

                    <div className="complementry_card_content">
                      {item?.foods?.map((food, j) => {
                        return (
                          <div key={j}>
                            <div className="vegetable_first">
                              <img src={food?.image} alt="Brocooli" />
                            </div>
                            <p>{food?.name}</p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>

            {selected?._id ? (

              <div className="col-lg-7 col-md-6 col-sm-6">
                <div className="complementry_rgt">
                  <div className="complementry_card">
                    <b>Date & Time</b>
                    <div className="date-time">
                      {dateFormatWithTime(selected?.feedingDateTime)}
                      <br />
                    </div>

                    {selected?.foods?.map((food, i) => {
                      return (
                        <div className="date-time" key={i}>
                          {food.name}
                          <br />
                        </div>
                      );
                    })}

                    {selected?.image && (
                      <div>
                        <b>Imagee</b>
                        <div className="image-wraper">
                          <img
                            src={selected?.image}
                            alt="Baby wrapped in towel"
                          />
                        </div>
                      </div>
                    )}

                    <div>
                      <b className="mt-4">Note</b>
                      <div className="motorskilltracking-note">
                        <p>{selected?.note}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default Complementry;
